import {all} from 'redux-saga/effects'
import {combineReducers} from 'redux'

import * as auth from '../../app/modules/auth'
import {productsReducer, workspaceReducer, driverReducer} from '../../app/@reducer'

export const rootReducer = combineReducers({
  auth: auth.reducer,
  workspace: workspaceReducer.reducer,
  products: productsReducer.reducer,
  driver: driverReducer.reducer,
})

export type RootState = ReturnType<typeof rootReducer>

export function* rootSaga() {
  yield all([auth.saga()])
}
